import React from "react";
import BaseMessage from "../../sisu/messages/BaseMessage.sisu";
import NeoColumn from "../layout/NeoColumn.base";

const NeoMessages = React.forwardRef((props, ref) => {
  return (<NeoColumn extra="p-mb-3" col="12"><BaseMessage {...props} ref={ref} /></NeoColumn>);
})

export default NeoMessages;